var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import { Col, Row } from "react-bootstrap";
import EdModal from "@frameworks/web/components/generic/edModal";
var MessagePopup = function (props) {
    var _a = __read(React.useState(true), 2), show = _a[0], setShow = _a[1];
    return (React.createElement("div", { className: "message-popup-family" },
        React.createElement(EdModal, { closeDropdown: function () { }, show: show, setShow: setShow, modalTitle: "message-pop-up sales-client commonmodal add-contact", size: "modal-md modal-dialog-centered", showFooter: false }, React.createElement(React.Fragment, null,
            React.createElement(Row, { className: "mb-4" },
                React.createElement(Col, { lg: 12, className: "d-flex justify-content-center" },
                    React.createElement("img", { src: props.imgContent })),
                React.createElement(Col, { lg: 12, className: "d-flex justify-content-center DMSansBold_20_700 mt-30 px-5 text-center" },
                    React.createElement("span", null, props.title)))))));
};
export default MessagePopup;
